require('./cardsControlHistoryView.scss')

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('commonsComponents/OKButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OKLink } = require('commonsComponents/OKLink');
const LastMovementsTable = require('components/commons/lastMovementsTable/lastMovementsTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const cardsControlHistoryTableRow = require('./cardsControlHistoryTableRow/cardsControlHistoryTableRow');
const { EmptyState } = require('commonsComponents/emptyState');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_LOCALE,
    DATE_PICKER_CUSTOM_DATE_FORMAT
} = require('constants/commonsComponents');

const QUERY_MIN_DATE = moment().startOf('day').subtract(5, 'years');
const QUERY_MAX_DATE = moment().startOf('day');

class CardsControlHistoryView extends React.Component {
    constructor(props) {
        super(props);
        this.handleGetQueryResults = this.handleGetQueryResults.bind(this);
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
    }

    componentWillUnmount() {
        this.props.reset()
    }

    fetchCardHistory(isFirstFetch) {
        const {
            match: { params: { cardId } },
            immCards
        } = this.props;

        const immCard = immCards.getIn(['byId', cardId]);
        const pan = immCard.get('number').replace(/ /g, '');
        this.props.getQueryResults(pan, isFirstFetch);
    }

    handleGetQueryResults() {
        this.fetchCardHistory()
    }

    handleShowMoreClick() {
        this.fetchCardHistory(false);
    }

    buildHeader() {
        const {
            match: { params: { cardId } },
            immCards
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const titleHeader = formatText('cardsControlHistory-title');
        const breadCrumbMap = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.getIn(['alias', 'current']),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardsConfig-title'),
                url: `/myprofile/cards/config/${cardId}`
            },
            {
                text: formatText('cardsControlHistory-title')
            },
        ];

        return (
            <OKHeaderCC
                title={titleHeader}
                breadcrumbConfig={breadCrumbMap}
                showBreadBrumb={true}
            />
        )
    }

    buildFilterBar() {
        const {
            immCardsControlHistory,
            setDateFrom,
            setDateTo,
        } = this.props;
        const dateFrom = immCardsControlHistory.get('filterDateFrom');
        const dateTo = immCardsControlHistory.get('filterDateTo');
        const isValidSelection = immCardsControlHistory.get('isValidSelection');

        return (
            <div className="cards-control-history-search">
                <div className="cards-control-history-search__filter-from">
                    <DatePickerCustom
                        callback={setDateFrom}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        label={formatText("cardsControlHistory-datePickerFrom")}
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        maxDate={QUERY_MAX_DATE}
                        minDate={QUERY_MIN_DATE}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        selectedDate={dateFrom}
                    />
                </div>
                <div className="cards-control-history-search__filter-to">
                    <DatePickerCustom
                        callback={setDateTo}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        label={formatText("cardsControlHistory-datePickerTo")}
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        maxDate={QUERY_MAX_DATE}
                        minDate={QUERY_MIN_DATE}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        selectedDate={dateTo}
                        innerSmallContainer
                    />
                </div>
                <div className="cards-control-history-search__button">
                    <OKButton
                        onClick={this.handleGetQueryResults}
                        modifier="primary"
                        disabled={!isValidSelection}
                    >
                        <FormattedText value="cardsControlHistory-submitButton" />
                    </OKButton>
                </div>
            </div>
        )
    }

    buildContent() {
        const {
            immCardsControlHistory
        } = this.props;
        const errorMessage = formatText('cardsControlHistory-fetchingError');
        const validationMessage = formatText('cardsControlHistory-inputError');
        const noResultsText = formatText('cardsControlHistory-noResults');
        const contentClass = 'cards-control-history-filter-content';
        let content;

        if (immCardsControlHistory.get('isFetching')) {
            content = (
                <div className={`${contentClass}__loading`}>
                    <LoadingSection />
                </div>
            );
        } else if (!immCardsControlHistory.get('isValidSelection')) {
            content = (
                <div className={`${contentClass}`}>
                    <p className={`${contentClass}__error`}>{validationMessage}</p>
                </div>
            );
        } else if (immCardsControlHistory.get('error')) {
            content = (
                <div className={`${contentClass}`}>
                    <p className={`${contentClass}__error`}>{errorMessage}</p>
                </div>
            );
        } else if (immCardsControlHistory.get('results')) {
            const cardControlMovements = immCardsControlHistory.get('results');
            const resultsByID = cardControlMovements.get('byId');
            const resultsByOrder = cardControlMovements.get('byOrder');
            const COLUMNS_COUNT = 4;

            if (resultsByOrder.size === 0) {
                content = (
                    <div className={`${contentClass}__no-results`}>
                        <EmptyState primaryText={noResultsText} iconType="search-banking" />
                    </div>
                );
            } else {
                content = (
                    <LastMovementsTable
                        groupByDate={false}
                        rowComponent={cardsControlHistoryTableRow}
                        immTransactionsById={resultsByID}
                        immTransactionsByOrder={resultsByOrder}
                        columnsCount={COLUMNS_COUNT}
                        id={`${contentClass}__results`}
                    >
                        <thead>
                            <OKTableRow asHeader={true}>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="cardsControlHistory-headerTableDate" />
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="cardsControlHistory-headerTableTime" />
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="cardsControlHistory-headerTableChanel" />
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="cardsControlHistory-headerTableOperative" />
                                </OKTableCell>
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                );
            }
        }

        return content;
    }

    buildShowMoreButton() {
        const { immCardsControlHistory } = this.props;
        const showMoreLabel = formatText('cardsControlHistory-showMore')
        const showMoreIsVisible = immCardsControlHistory.get('hasMore');

        return showMoreIsVisible && (
            <div className="cards-control-history-showmore">
                <OKLink
                    modifier="complementary"
                    onClick={this.handleShowMoreClick}
                    children={showMoreLabel}
                />
            </div>
        );
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();
        const filterBar = this.buildFilterBar();
        const showMoreButton = this.buildShowMoreButton();

        const headerTitle = (
            <div>
                {formatText('cardsControlHistory-headerTitle')}
            </div>
        );

        return (
            <section className="cards-control-history">
                {header}
                <div className="grid-view__body cards-control-history__body">
                    <div className="container-fluid cards-control-history__container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="cards-control-history-wrapper">
                                    <header className="cards-control-history-header">
                                        <div className="cards-control-history-header__title">
                                            <OKBoxTitle value={headerTitle} />
                                        </div>
                                    </header>
                                    {filterBar}
                                    {content}
                                    {showMoreButton}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

CardsControlHistoryView.propTypes = {
    getQueryResults: PropTypes.func.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsControlHistory: PropTypes.object.isRequired,
    match: PropTypes.object,
    reset: PropTypes.func.isRequired,
    setDateFrom: PropTypes.func,
    setDateTo: PropTypes.func
};

module.exports = CardsControlHistoryView;
